import { Component, OnInit, ViewChild } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { GuardianNotifyBatchExportComponent } from "./guardian-notify-batch-export/guardian-notify-batch-export.component";
import { GuardianNotifyBatchImportComponent } from "./guardian-notify-batch-import/guardian-notify-batch-import.component";
import { GuardianNotifyDownloadComponent } from "./guardian-notify-download/guardian-notify-download.component";
import { GuardianNotifyEmailLogComponent } from "./guardian-notify-email-log/guardian-notify-email-log.component";
import { GuardianNotifyImportPreviewComponent } from "./guardian-notify-import-preview/guardian-notify-import-preview.component";
import { BatchGuardianEmailRequest } from "./shared/BatchGuardianEmailRequest";
import { BatchGuardianUpdateLanguageRequest } from "./shared/BatchGuardianUpdateLanguageRequest";
import { DataService_NotifyRegBatch } from "./shared/data.service";

@Component({
	selector: "app-guardian-notification-batch",
	templateUrl: "./guardian-notification-batch.component.html",
	styleUrls: ["./guardian-notification-batch.component.css"],
})
export class GuardianNotificationBatchComponent implements OnInit {
	constructor(
		private userService: UserService,
		private notifyService: DataService_NotifyRegBatch,
		private dialogService: DialogService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();
	}

	//////////////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////////////

	user: any;

	ImportPreviewExpand: any = false;
	EmailLogExpand: any = false;

	IsProcessing: any = false;

	FormatOption: any;
	ImportFileData: any;

	errorMessage: any = "";

	@ViewChild(GuardianNotifyImportPreviewComponent)
	previewRef: GuardianNotifyImportPreviewComponent;

	@ViewChild(GuardianNotifyEmailLogComponent)
	emailLogRef: GuardianNotifyEmailLogComponent;

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Load Data
	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////////////
	onImport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GuardianNotifyBatchImportComponent, {
			header: "Guardian Notification Import",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != "close") {
				this.FormatOption = response[0];
				this.ImportFileData = response[1];

				this.ImportPreviewExpand = true;
				this.EmailLogExpand = false;
			}
		});
	}

	onClear() {
		this.previewRef.lstPerson = [];
	}

	onDownload() {
		this.errorMessage = "";

		if (this.previewRef.lstPerson.length == 0) {
			this.errorMessage = "No import data to download (Import preview table is empty)";
			return;
		}

		//
		// Pick Format
		//
		var ref = this.dialogService.open(GuardianNotifyDownloadComponent, {
			header: "Select Format to Download",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != "close") {
				this.FinishDownload(response);
			}
		});
	}

	FinishDownload(FormatOption) {
		//
		// Text, Tab delimited
		//
		if (FormatOption.ID == 1) {
			this.DownloadImportTextTab();
		}
		//
		// Text, Commas
		//
		else if (FormatOption.ID == 2) {
			this.DownloadImportTextCommas();
		}
		//
		// CSV
		//
		else if (FormatOption.ID == 3) {
			this.DownloadImportCSV();
		}
	}

	DownloadImportTextTab() {
		var DataStr: string = "";

		for (var z = 0; z < this.previewRef.lstPerson.length; z++) {
			var next = this.previewRef.lstPerson[z];

			DataStr += next.StudentID;
			DataStr += "\t";
			DataStr += next.ParentName;
			DataStr += "\t";
			DataStr += next.ParentEmail;
			DataStr += "\t";
			DataStr += next.LanguageDesc;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/plain," + DataStr;
		a.download = FileName + ".txt";

		this.IsProcessing = false;

		a.click(); //Downloaded file
	}

	DownloadImportTextCommas() {
		var DataStr: string = "";

		for (var z = 0; z < this.previewRef.lstPerson.length; z++) {
			var next = this.previewRef.lstPerson[z];

			DataStr += '"' + next.StudentID + '"';
			DataStr += ",";
			DataStr += '"' + next.ParentName + '"';
			DataStr += ",";
			DataStr += '"' + next.ParentEmail + '"';
			DataStr += ",";
			DataStr += '"' + next.LanguageDesc + '"';
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/plain," + DataStr;
		a.download = FileName + ".txt";

		this.IsProcessing = false;

		a.click(); //Downloaded file
	}

	DownloadImportCSV() {
		var DataStr: string = "";

		for (var z = 0; z < this.previewRef.lstPerson.length; z++) {
			var next = this.previewRef.lstPerson[z];

			DataStr += '"' + next.StudentID + '"';
			DataStr += ",";
			DataStr += '"' + next.ParentName + '"';
			DataStr += ",";
			DataStr += '"' + next.ParentEmail + '"';
			DataStr += ",";
			DataStr += '"' + next.LanguageDesc + '"';
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "ImportData";

		a.href = "data:text/csv," + DataStr;
		a.download = FileName + ".csv";

		this.IsProcessing = false;

		a.click(); //Downloaded file
	}

	onExport() {
		this.errorMessage = "";

		var ref = this.dialogService.open(GuardianNotifyBatchExportComponent, {
			header: "Guardian Notification Export",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != "close") {
			}
		});
	}

	onEmail() {
		this.errorMessage = "";

		//
		// Check if any data was imported
		//
		if (this.previewRef.lstPerson.length == 0) {
			this.errorMessage = "Import a list of students and guardians to email. NOTE: You can export a list, make changes to it and then re-import it";
			return;
		}

		//
		// Check if any of the data is valid
		//
		var lstValid: any = [];
		lstValid = Array.from(this.previewRef.lstPerson).filter((person: any) => person.ValidEntry == 1 && person.ParentName != "" && person.ParentEmail != "");

		if (lstValid.length == 0) {
			this.errorMessage =
				"No valid guardians to email. Make sure the student IDs, parent names, and parent emails are filled in correctly or import new data.";
			return;
		}

		this.ConfirmEmail(lstValid);
	}

	ConfirmEmail(lstValid) {
		var MSG = "You are about to send ";
		MSG += lstValid.length + " email(s). Do you want to continue?";

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Send Emails",
			icon: "fa",
			accept: () => {
				this.FinishEmail(lstValid);
			},
			reject: () => {},
		});
	}

	FinishEmail(lstValid) {
		this.IsProcessing = true;

		//
		// Create Request
		//

		let lstStudentID: string[] = [];
		let lstStudentPersonID: number[] = [];
		let lstGuardianName: string[] = [];
		let lstGuardianEmail: string[] = [];
		let lstLanguageDesc: string[] = [];

		for (var z = 0; z < lstValid.length; z++) {
			var next = lstValid[z];

			lstStudentID = [...lstStudentID, next.StudentID];
			lstStudentPersonID = [...lstStudentPersonID, next.PersonID];
			lstGuardianName = [...lstGuardianName, next.ParentName];
			lstGuardianEmail = [...lstGuardianEmail, next.ParentEmail];
			lstLanguageDesc = [...lstLanguageDesc, next.LanguageDesc];
		}

		let parms: BatchGuardianEmailRequest = {
			Admin_PersonID: this.user.personID,
			lstStudentID: lstStudentID,
			lstStudentPersonID: lstStudentPersonID,
			lstGuardianName: lstGuardianName,
			lstGuardianEmail: lstGuardianEmail,
			lstLanguageDesc: lstLanguageDesc,
		};

		var result = this.notifyService.BatchGuardianEmail(parms);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main2",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Batch email sent successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ImportPreviewExpand = false;
							this.EmailLogExpand = true;
							this.emailLogRef.onRefresh();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main2",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not send emails",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onUpdateLanguages() {
		this.errorMessage = "";

		//
		// Check if any data was imported
		//
		if (this.previewRef.lstPerson.length == 0) {
			this.errorMessage =
				"Import a list of students to update their language preferences for CAASS Notify. NOTE: You can export a list, make changes to it and then re-import it";
			return;
		}

		//
		// Check if any of the data is valid
		//
		var lstValid: any = [];
		lstValid = Array.from(this.previewRef.lstPerson).filter((person: any) => person.ValidEntry == 1);

		if (lstValid.length == 0) {
			this.errorMessage = "No valid students to update. Make sure the student IDs, and language options are filled in correctly or import new data.";
			return;
		}

		this.ConfirmLanguageUpdate(lstValid);
	}

	ConfirmLanguageUpdate(lstValid) {
		var MSG = "You are about to update the languages for ";
		MSG += lstValid.length + " student(s). NOTE: only the last entry for each student will be used. Do you want to continue?";

		this.confirmationService.confirm({
			key: "main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: MSG,
			header: "Confirm Update Language Preferences",
			icon: "fa",
			accept: () => {
				this.FinishUpdateLanguage(lstValid);
			},
			reject: () => {},
		});
	}

	FinishUpdateLanguage(lstValid) {
		this.IsProcessing = true;

		//
		// Create Request
		//

		let lstStudentPersonID: number[] = [];
		let lstLanguageDesc: string[] = [];

		for (var z = 0; z < lstValid.length; z++) {
			var next = lstValid[z];

			lstStudentPersonID = [...lstStudentPersonID, next.PersonID];
			lstLanguageDesc = [...lstLanguageDesc, next.LanguageDesc];
		}

		let parms: BatchGuardianUpdateLanguageRequest = {
			lstStudentPersonID: lstStudentPersonID,
			lstLanguageDesc: lstLanguageDesc,
		};

		var result = this.notifyService.BatchGuardianUpdateLanguage(parms);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "main2",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Language preferences updated successfully. NOTE: If you have multiple entries for the same student, only the last entry will be used",
						header: "Success",
						icon: "fa",
						accept: () => {},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "main2",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update language preferences",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////////////

	IsLoading() {
		if (this.previewRef != undefined) {
			return this.IsProcessing == true || this.previewRef.loading == true || this.previewRef.AnyLoading == true;
		} else {
			return this.IsProcessing == true;
		}
	}

	//////////////////////////////////////////////////////////////////////////////
}
